import styled from "styled-components";

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #666;
  font-size: 0.9rem;
`;